<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div id="information-recruit" class="inner-wrap">

  <ul class="recruit-tab">
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: params.tab=='offer'}" (click)="tabChange('offer')">구인</a></li>
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: params.tab=='search'}" (click)="tabChange('search')">구직</a></li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane" [ngClass]="{show: params.tab=='offer', active: params.tab=='offer', fadeIn: params.tab=='offer', fade: params.tab=='search'}">
      <div class="recruit1" *ngIf="params.type=='list'">
			  <table class="hlist-table">
			  <colgroup>
          <col style="width:10%;">
          <col style="width:56%;">
          <col style="width:12%;">
          <col style="width:12%;">
          <col style="width:10%;">
			  </colgroup>

			  <thead>
			  <tr>
			    <th>번호</th>
			    <th>제목</th>
			    <th>모집부분</th>
			    <th>등록자</th>
			    <th>등록일자</th>
			  </tr>
			  </thead>
        <tbody>
          <tr *ngFor="let row of boardList; index as i">
            <td>{{totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</td>
            <td class="tl">
              <a class="cp" (click)="view(row)">{{row.subject}}</a>
            </td>
            <td>{{row.career}} / {{row.recuritment_part}}</td>
            <td>{{row.charge}}</td>
            <td>{{row.write_date.substr(0, 10)}}</td>
          </tr>
          </tbody>
			  </table>

			  <a class="apply-btn" (click)="write()">신청하기</a>
        <div class="cb"></div>

		    <div class="pagination-area">
		      <ngb-pagination
            [(page)]="params.no"
            [pageSize]="params.row"
            [maxSize]="maxSize"
            [collectionSize]="totalCount"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
            >
		        <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
		        <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
		        <ng-template ngbPaginationPrevious>&lt;</ng-template>
		        <ng-template ngbPaginationNext>&gt;</ng-template>
		      </ngb-pagination>
		    </div>
	    </div>
	    <app-recruit-view1 *ngIf="params.tab=='offer' && params.type=='view'" [memberInfo]="memberInfo"></app-recruit-view1>
	    <app-recruit-add1 *ngIf="params.tab=='offer' && (params.type=='write' || params.type=='modify')"></app-recruit-add1>

    </div>
    <div class="tab-pane" [ngClass]="{show: params.tab=='search', active: params.tab=='search', fadeIn: params.tab=='search', fade: params.tab=='offer'}">
      <div class="recruit2" *ngIf="params.type=='list'">
	      <table class="hlist-table">
	      <colgroup>
	        <col style="width:10%;">
	        <col style="width:56%;">
	        <col style="width:12%;">
	        <col style="width:12%;">
	        <col style="width:10%;">
	      </colgroup>

	      <thead>
	      <tr>
	        <th>번호</th>
	        <th>제목</th>
	        <th>모집부분</th>
	        <th>등록자</th>
	        <th>등록일자</th>
	      </tr>
	      </thead>

	      <tbody>
        <tr *ngFor="let row of boardList; index as i">
          <td>{{totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</td>
          <td class="tl">
            <a class="cp" (click)="view(row)">{{row.subject}}</a>
          </td>
          <td>신입/전체</td>
          <td>{{row.name}}</td>
          <td>{{row.write_date.substr(0, 10)}}</td>
        </tr>
        </tbody>
        </table>

	      <a class="apply-btn" (click)="write()">신청하기</a>
	      <div class="cb"></div>

	      <div class="pagination-area">
	        <ngb-pagination
            [(page)]="params.no"
            [pageSize]="params.row"
            [maxSize]="maxSize"
		        [collectionSize]="totalCount"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
	          >
	          <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
	          <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
	          <ng-template ngbPaginationPrevious>&lt;</ng-template>
	          <ng-template ngbPaginationNext>&gt;</ng-template>
	        </ngb-pagination>
	      </div>
      </div>
      <app-recruit-view2 *ngIf="params.tab=='search' && params.type=='view'" [memberInfo]="memberInfo"></app-recruit-view2>
      <app-recruit-add2 *ngIf="params.tab=='search' && (params.type=='write' || params.type=='modify')"></app-recruit-add2>

    </div>
  </div>
</div>

<app-footer></app-footer>
